import _extends from 'babel-runtime/helpers/extends';

import starButton from './star-button.vue';
import transName from './trans-name.vue';
import { mapState } from 'vuex';

export default {
  name: 'node',

  props: {
    node: {
      type: Object,
      required: true
    },

    currentNodeKey: {
      type: [Number, String]
    },

    renderContent: {
      type: Object
    }
  },
  components: {
    starButton: starButton,
    transName: transName
  },

  computed: _extends({}, mapState({
    activeCategoryNode: function activeCategoryNode(state) {
      return state.creative.template.activeCategoryNode;
    }
  }), {
    hasChildren: function hasChildren() {
      return Array.isArray(this.node.sub_category) && this.node.sub_category.length > 0 && this.node.level <= 2;
    }
  })
};